import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Blocks OS gateway names query operations `get<Collection>`, not the bare collection name. Each
 * operation is aliased to the collection name so services and hooks keep reading `result.<Collection>`.
 * Confirm exact names with `blocks data schema get <id>`.
 *
 * A to Z by title by default, like the old designation list's `{ Title: 1 }` sort.
 */
export const DEFAULT_DESIGNATIONS_ORDER: OrderBy[] = [{ field: 'Title', direction: 'ASC' }];

export const buildGetDesignationsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_DESIGNATIONS_ORDER
) => `
  query {
    Designations: getDesignations(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        Title
        Weight
      }
    }
  }
`;
